export const priceFormat = {
    formatMinorPrice(value, formatter, isNegative) {
        const price = formatter.format(value);
        if (isNegative) {
            return '- ' + price;
        }
        return price;
    },
};
//# sourceMappingURL=priceFormat.js.map